(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["owc-read-more"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('owc-read-more')) return;

    class OwcReadMore extends HTMLElement {
      connectedCallback() {
        this.toggleBtn = this.querySelector('[data-rm-toggle]');
        this.clampEl = this.querySelector('.owc-rm__body--clamp');
        this.restEl = this.querySelector('.owc-rm__rest');
        if (!this.toggleBtn) return;

        this.expanded = this.classList.contains('is-expanded');
        this.handleClick = () => (this.expanded ? this.collapse() : this.expand());
        this.toggleBtn.addEventListener('click', this.handleClick);

        this.observer = new ResizeObserver(() => this.refresh());
        this.observer.observe(this);
        const content = this.clampEl && this.clampEl.firstElementChild;
        if (content) this.observer.observe(content);

        this.sync();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.toggleBtn) this.toggleBtn.removeEventListener('click', this.handleClick);
      }

      get canAnimate() {
        return this.dataset.animate === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      isActive() {
        return getComputedStyle(this).getPropertyValue('--rm-actions-display').trim() !== 'none';
      }

      refresh() {
        const active = this.isActive();
        if (this.clampEl && !this.expanded) {
          const fits = !active || this.clampEl.scrollHeight <= this.clampEl.clientHeight + 2;
          this.classList.toggle('is-fits', fits);
        }
        if (this.restEl) this.restEl.inert = active && !this.expanded;
      }

      sync() {
        this.toggleBtn.setAttribute('aria-expanded', String(this.expanded));
        this.refresh();
      }

      afterTransition(el, callback) {
        let done = false;
        const finish = (event) => {
          if (event && (event.target !== el || event.propertyName !== 'max-height')) return;
          if (done) return;
          done = true;
          el.removeEventListener('transitionend', finish);
          callback();
        };
        el.addEventListener('transitionend', finish);
        window.setTimeout(() => finish(), 700);
      }

      expand() {
        if (this.expanded) return;
        this.expanded = true;
        const el = this.clampEl;
        if (el && this.canAnimate) {
          el.style.maxHeight = `${el.clientHeight}px`;
          this.classList.add('is-expanded');
          void el.offsetHeight;
          el.style.maxHeight = `${el.scrollHeight}px`;
          this.afterTransition(el, () => {
            if (this.expanded) el.style.maxHeight = '';
          });
        } else {
          this.classList.add('is-expanded');
        }
        this.sync();
      }

      collapse(options = {}) {
        if (!this.expanded) return;
        this.expanded = false;
        const el = this.clampEl;
        if (el && this.canAnimate) {
          el.style.maxHeight = `${el.scrollHeight}px`;
          void el.offsetHeight;
          this.classList.remove('is-expanded');
          el.style.maxHeight = '';
        } else {
          this.classList.remove('is-expanded');
        }
        this.sync();

        const shouldScroll = options.scroll !== false && this.dataset.scroll === 'true';
        if (shouldScroll) {
          requestAnimationFrame(() => {
            if (this.getBoundingClientRect().top < 0) {
              this.scrollIntoView({ block: 'start', behavior: this.canAnimate ? 'smooth' : 'auto' });
            }
          });
        }
      }
    }

    customElements.define('owc-read-more', OwcReadMore);

    /* Theme editor: open the full text while the block is selected */
    document.addEventListener('shopify:block:select', (event) => {
      const el = event.target && event.target.closest ? event.target.closest('owc-read-more') : null;
      if (el && typeof el.expand === 'function') el.expand();
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const el = event.target && event.target.closest ? event.target.closest('owc-read-more') : null;
      if (el && typeof el.collapse === 'function') el.collapse({ scroll: false });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
